export const BUSINESS_INFO = {
  companyName: '베이트아인',
  companyNameEn: 'Bateain',
  representative: '강성민',
  bizNumber: '717-59-00810',
  mailOrderBizNumber: '2026-서울관악-0553',
  address: '서울특별시 관악구 봉천로 408-1',
  businessCategory: '도매 및 소매업',
  businessItem: '전자상거래 소매업',
  taxType: '부가가치세 일반과세자',
  entityType: '개인과세사업자',
  registeredAt: '2026-03-17',
  inquiryEmail: 'hello@newflix.io',
  privacyOfficerEmail: 'hello@newflix.io',
  serviceName: 'newflix',
  serviceUrl: 'https://newflix.io',
};

export const LAST_UPDATED = '2026-05-20';

export type LegalKind = 'tos' | 'privacy' | 'cookies' | 'business';

export interface LegalSection {
  title: string;
  body: string;
}

export interface LegalDoc {
  title: string;
  subtitle?: string;
  lastUpdated: string;
  sections: LegalSection[];
}

export const TOS: LegalDoc = {
  title: '이용약관',
  subtitle: 'newflix 서비스 이용에 관한 기본 규칙',
  lastUpdated: LAST_UPDATED,
  sections: [
    {
      title: '제1조 (목적)',
      body: `본 약관은 ${BUSINESS_INFO.companyName}(${BUSINESS_INFO.companyNameEn}, 이하 "회사")이 제공하는 newflix 서비스(이하 "서비스")의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 정함을 목적으로 합니다.`,
    },
    {
      title: '제2조 (용어의 정의)',
      body: `① "서비스"란 회사가 운영하는 newflix(${BUSINESS_INFO.serviceUrl}) 웹사이트 및 이와 관련된 제반 서비스를 의미합니다.
② "회원"이란 본 약관에 따라 회사와 이용계약을 체결하고 서비스를 이용하는 자를 말합니다.
③ "비회원"이란 회원으로 가입하지 않고 회사가 제공하는 서비스를 이용하는 자를 말합니다.
④ "메이커"란 자신이 운영·제작한 IT 서비스를 본 서비스에 등록·관리하는 회원을 말합니다.
⑤ "큐레이션"이란 회사가 외부에 공개된 IT 서비스 정보를 사전 수집·정리하여 본 서비스에 노출하는 행위를 말합니다.`,
    },
    {
      title: '제3조 (약관의 효력 및 변경)',
      body: `① 본 약관은 서비스 화면에 게시함으로써 효력이 발생합니다.
② 회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있으며, 개정 시 적용일자 7일 전(회원에게 불리한 변경은 30일 전)부터 공지합니다.
③ 회원이 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.`,
    },
    {
      title: '제4조 (회원가입)',
      body: `① 회원가입은 Google OAuth를 통해 이루어집니다.
② 회사는 다음 각 호에 해당하는 경우 가입을 거부하거나 사후에 이용계약을 해지할 수 있습니다.
  1. 타인의 정보를 도용한 경우
  2. 부정한 용도로 서비스를 이용하고자 하는 경우
  3. 관련 법령 또는 본 약관을 위반한 경우`,
    },
    {
      title: '제5조 (서비스의 제공 및 변경)',
      body: `① 회사는 다음과 같은 서비스를 제공합니다.
  1. IT 서비스 디스커버리(둘러보기, 검색, 카테고리)
  2. 찜·컬렉션·리뷰 등 회원 기능
  3. 메이커의 서비스 등록·관리 기능
  4. 기타 회사가 추가 개발하거나 제휴를 통해 제공하는 서비스
② 회사는 운영상·기술상 필요에 따라 제공 서비스의 전부 또는 일부를 변경할 수 있으며, 변경 시 사전 공지합니다.`,
    },
    {
      title: '제6조 (서비스 이용시간)',
      body: `① 서비스는 연중무휴 24시간 제공을 원칙으로 합니다.
② 정기 점검, 시스템 장애, 천재지변 등의 사유로 서비스 제공이 중단될 수 있으며, 회사는 이로 인한 회원의 손해에 대해 고의 또는 중과실이 없는 한 책임을 지지 않습니다.`,
    },
    {
      title: '제7조 (사전 큐레이션 및 메이커 권리)',
      body: `① 회사는 공개된 정보를 토대로 IT 서비스를 사전 큐레이션하여 본 서비스에 게시할 수 있습니다.
② 메이커는 자신이 운영하는 서비스 페이지의 소유권을 클레임하여 직접 관리할 수 있습니다.
③ 메이커 또는 정당한 권리자는 회사에 정보 수정·삭제를 요청할 수 있으며, 회사는 정당한 사유가 없는 한 합리적 기간 내에 처리합니다.
④ 회사는 정보의 출처를 명시하며, 저작권자의 합법적 요청 시 즉시 조치합니다.`,
    },
    {
      title: '제8조 (회원의 의무)',
      body: `① 회원은 다음 행위를 하여서는 안 됩니다.
  1. 타인의 정보 도용 또는 허위 사실 등록
  2. 회사 또는 제3자의 저작권 등 권리 침해
  3. 서비스 운영을 방해하는 행위(어뷰징·자동화 봇 등 포함)
  4. 공공질서 및 미풍양속을 위배하는 정보의 게시
  5. 관련 법령 또는 본 약관을 위반하는 행위
② 위반 시 회사는 사전 통지 없이 게시물 삭제·계정 정지·이용계약 해지 등 조치를 할 수 있습니다.`,
    },
    {
      title: '제9조 (회사의 의무)',
      body: `① 회사는 본 약관 및 관련 법령을 준수하고, 안정적인 서비스 제공을 위해 노력합니다.
② 회사는 회원의 개인정보를 본 서비스 개인정보처리방침에 따라 보호합니다.`,
    },
    {
      title: '제10조 (면책)',
      body: `① 회사는 천재지변, 전쟁, 시스템 장애, 기타 불가항력으로 서비스를 제공할 수 없는 경우 책임이 면제됩니다.
② 회사는 회원이 서비스 이용으로 기대한 수익이나 손실에 대해 책임을 지지 않습니다.
③ 회사는 회원 상호 간, 회원과 제3자 간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며, 이로 인한 손해를 배상할 책임이 없습니다.`,
    },
    {
      title: '제11조 (분쟁의 해결)',
      body: `본 약관과 관련하여 회사와 회원 간에 분쟁이 발생한 경우, 회사 본점 소재지의 관할 법원을 1심 법원으로 합니다.`,
    },
  ],
};

export const PRIVACY: LegalDoc = {
  title: '개인정보처리방침',
  subtitle: 'newflix가 수집·이용·보관하는 개인정보',
  lastUpdated: LAST_UPDATED,
  sections: [
    {
      title: '1. 수집 항목 및 방법',
      body: `회사는 다음의 개인정보를 수집합니다.
가. 회원가입 시 (Google OAuth)
  - 필수: Google 계정 식별자(id), 이메일, 이름
  - 선택: 프로필 이미지(picture)
나. 서비스 이용 과정에서 자동 생성·수집
  - 찜·컬렉션·리뷰·업보트 기록
  - 서비스 이용 기록, 접속 IP, 쿠키, 브라우저 정보, 기기 정보
  - 클릭·유입 경로 데이터 (수익화 기능 활성 시)
다. 수집 방법
  - Google OAuth 콜백을 통한 자동 수신
  - 회원의 서비스 이용 시 자동 수집`,
    },
    {
      title: '2. 수집 및 이용 목적',
      body: `가. 회원 식별 및 본인 확인
나. 서비스 제공 및 개인화(찜·컬렉션·추천)
다. 서비스 운영·개선, 신규 기능 개발
라. 부정 이용·어뷰징 방지
마. 법령상 의무 이행 및 분쟁 해결`,
    },
    {
      title: '3. 보유 및 이용 기간',
      body: `가. 원칙: 회원 탈퇴 시 또는 수집·이용 목적 달성 시 지체 없이 파기
나. 다만, 다음 정보는 관련 법령에 따라 일정 기간 보관
  - 부정 이용 방지를 위한 기록: 1년
  - 전자상거래법 등 관련 법령상 의무 보관 정보: 해당 법령상 기간
다. 탈퇴 처리는 30일의 유예 기간 후 영구 삭제 (복구 불가)`,
    },
    {
      title: '4. 제3자 제공',
      body: `회사는 회원의 개인정보를 외부에 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.
  - 회원이 사전 동의한 경우
  - 법령에 근거가 있거나 수사기관의 적법한 절차에 따른 요청이 있는 경우`,
    },
    {
      title: '5. 처리 위탁',
      body: `회사는 서비스 운영을 위해 다음 업체에 일부 처리 업무를 위탁합니다.
  - Google LLC: OAuth 인증
  - Cloudflare, Inc.: CDN·자산 호스팅(R2)·이메일 라우팅
  - Resend, Inc.: 트랜잭셔널 이메일 발송
  - Functional Software, Inc. (Sentry): 에러 모니터링
  - Anthropic, PBC: 메타데이터 추출(서비스 정보)
위탁 업체의 개인정보 처리 현황 및 변경 사항은 본 방침을 통해 즉시 공개합니다.`,
    },
    {
      title: '6. 이용자의 권리',
      body: `회원은 언제든지 다음의 권리를 행사할 수 있습니다.
  - 개인정보 열람·정정·삭제 요청
  - 처리 정지 요청
  - 회원 탈퇴 (계정 삭제)
  - 동의 철회
권리 행사는 ${BUSINESS_INFO.privacyOfficerEmail} 또는 마이페이지를 통해 가능합니다.`,
    },
    {
      title: '7. 개인정보의 안전성 확보 조치',
      body: `회사는 다음과 같은 기술적·관리적 조치를 시행합니다.
  - HTTPS 전 구간 암호화
  - 세션 토큰 (JWT) httpOnly·SameSite·Secure 적용
  - 관리자 접근 권한 분리 및 감사
  - 시크릿 회전 정책 운영
  - 정기 보안 점검 및 취약점 패치`,
    },
    {
      title: '8. 쿠키 사용',
      body: `본 서비스는 세션 유지·OAuth 상태 검증 등 필수 목적의 쿠키를 사용합니다. 자세한 내용은 별도의 쿠키 정책을 참고하십시오.`,
    },
    {
      title: '9. 개인정보 보호 책임자',
      body: `책임자: ${BUSINESS_INFO.representative}
연락처: ${BUSINESS_INFO.privacyOfficerEmail}
정보 주체는 위 연락처로 개인정보 관련 문의·신고·구제를 요청할 수 있습니다.`,
    },
    {
      title: '10. 권익침해 구제 방법',
      body: `개인정보 침해로 인한 신고·상담이 필요하신 경우 아래 기관에 문의하실 수 있습니다.
  - 개인정보보호위원회 (privacy.go.kr / 국번없이 182)
  - 개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)
  - 대검찰청 사이버수사과 (spo.go.kr / 국번없이 1301)
  - 경찰청 사이버수사국 (ecrm.cyber.go.kr / 국번없이 182)`,
    },
    {
      title: '11. 방침 변경',
      body: `본 방침은 법령·서비스 변경에 따라 개정될 수 있으며, 개정 시 시행일자 7일 전부터 공지합니다. 중대한 변경은 30일 전부터 공지합니다.`,
    },
  ],
};

export const COOKIES: LegalDoc = {
  title: '쿠키 정책',
  subtitle: '본 서비스가 사용하는 쿠키의 종류와 목적',
  lastUpdated: LAST_UPDATED,
  sections: [
    {
      title: '쿠키란?',
      body: `쿠키는 회원이 웹사이트에 접속할 때 브라우저에 저장되는 작은 텍스트 파일입니다. 본 서비스는 안정적인 서비스 제공과 보안을 위해 필수 쿠키를 사용합니다.`,
    },
    {
      title: '사용 쿠키 목록',
      body: `가. 세션 쿠키 (session)
  - 목적: 로그인 상태 유지
  - 종류: JWT (HS256 서명)
  - 속성: HttpOnly, SameSite=Lax, Secure(운영 환경)
  - 만료: 30일

나. OAuth 상태 쿠키 (oauth2_state_google)
  - 목적: Google OAuth CSRF 방어
  - 속성: HttpOnly, SameSite=Lax, Secure(운영 환경)
  - 만료: 10분 (인증 완료 후 즉시 삭제)`,
    },
    {
      title: '제3자 쿠키',
      body: `본 서비스는 현재 광고 추적 등 비필수 제3자 쿠키를 사용하지 않습니다. 향후 분석 도구(예: Plausible, Google Analytics) 도입 시 본 정책을 업데이트하고 사용자에게 사전 동의를 받습니다.`,
    },
    {
      title: '쿠키 거부 방법',
      body: `사용자는 브라우저 설정에서 쿠키를 거부할 수 있습니다. 단, 세션 쿠키를 거부할 경우 로그인 기반 기능(찜, 컬렉션 등)을 이용할 수 없습니다.`,
    },
    {
      title: '문의',
      body: `쿠키 사용 관련 문의: ${BUSINESS_INFO.privacyOfficerEmail}`,
    },
  ],
};

export const BUSINESS: LegalDoc = {
  title: '사업자 정보',
  subtitle: '전자상거래법 · 통신판매에 관한 법률에 따른 사업자 등록 정보',
  lastUpdated: LAST_UPDATED,
  sections: [
    {
      title: '운영 주체',
      body: `상호: ${BUSINESS_INFO.companyName} (${BUSINESS_INFO.companyNameEn})
대표자: ${BUSINESS_INFO.representative}
사업자등록번호: ${BUSINESS_INFO.bizNumber}
통신판매업 신고번호: ${BUSINESS_INFO.mailOrderBizNumber}
사업장 주소: ${BUSINESS_INFO.address}
업태 / 종목: ${BUSINESS_INFO.businessCategory} / ${BUSINESS_INFO.businessItem}
법인 형태: ${BUSINESS_INFO.entityType}
과세 유형: ${BUSINESS_INFO.taxType}
등록일: ${BUSINESS_INFO.registeredAt}`,
    },
    {
      title: '서비스 정보',
      body: `서비스명: ${BUSINESS_INFO.serviceName}
서비스 URL: ${BUSINESS_INFO.serviceUrl}`,
    },
    {
      title: '연락처',
      body: `문의: ${BUSINESS_INFO.inquiryEmail}
개인정보 보호 책임자: ${BUSINESS_INFO.privacyOfficerEmail}`,
    },
    {
      title: '안내',
      body: `유료 결제가 활성화되는 시점에 결제대행사(PG) 연계, 청약 철회·환불 절차, 분쟁 해결 기준 등이 본 페이지에 추가됩니다.`,
    },
  ],
};

export const LEGAL_DOCS: Record<LegalKind, LegalDoc> = {
  tos: TOS,
  privacy: PRIVACY,
  cookies: COOKIES,
  business: BUSINESS,
};

export const LEGAL_NAV: { kind: LegalKind; label: string }[] = [
  { kind: 'tos', label: '이용약관' },
  { kind: 'privacy', label: '개인정보처리방침' },
  { kind: 'cookies', label: '쿠키 정책' },
  { kind: 'business', label: '사업자 정보' },
];
